var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBullhornGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2504",
    "data-name": "Rectangle 2504",
    width: 30,
    height: 26,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bullhorn",
    transform: "translate(-80 -177)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2503",
    "data-name": "Rectangle 2503",
    width: 40,
    height: 40,
    rx: 4,
    transform: "translate(80 177)",
    fill: "#8c8c8c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12936",
    "data-name": "Group 12936",
    transform: "translate(85 184)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12935",
    "data-name": "Group 12935",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12938",
    "data-name": "Path 12938",
    d: "M0,4.945c.623.214,1.132.429,1.661.563A5.9,5.9,0,0,0,5.448,5.1a.578.578,0,0,0,.291-.251,1.478,1.478,0,0,1,1.445-.811.885.885,0,0,0,.791-.413,1.573,1.573,0,0,1,1.844-.529.752.752,0,0,0,.514.007,14.454,14.454,0,0,0,1.525-.765c.38-.225.373-.415,0-.658-.645-.424-1.3-.825-1.956-1.237A.65.65,0,0,1,9.718.295,1.426,1.426,0,0,1,9.6.031.711.711,0,0,1,9.868.009q1.59.544,3.173,1.107a3.176,3.176,0,0,1,.649.293.757.757,0,0,1,.19,1.24c-.469.49-1.01.907-1.524,1.351a3.912,3.912,0,0,1-.373.249c.364.382.787-.018,1.109.15l-.346.638.667.348c-.013.369.236.518.664.542a6.689,6.689,0,0,1,1.161.226,1.025,1.025,0,0,1,.507.209,2.981,2.981,0,0,0,1.642.715,4.159,4.159,0,0,1,3.107,3.053c.126.414.264.825.4,1.235.045.133.111.258.168.386l.138-.031c-.04-.3-.062-.612-.124-.912-.1-.464-.217-.923-.329-1.383-.135-.559.03-.744.543-.573A15.542,15.542,0,0,1,25.238,10.6a1.779,1.779,0,0,1,.814,1.287.729.729,0,0,0,.148.368,5.1,5.1,0,0,1,.959,2.336,2.365,2.365,0,0,0,.388.875.911.911,0,0,0,1.606-.143,2.784,2.784,0,0,1,.609-.541c.406.513.274.947-.262,1.1a5.177,5.177,0,0,1-.7.239,3.4,3.4,0,0,1-1.073.013c-.3-.059-.407-.055-.417.289-.023.837-.077,1.673-.113,2.51a.584.584,0,0,0,.044.316,1.978,1.978,0,0,1,.236,1.439,2.332,2.332,0,0,0,.536,1.74,2.121,2.121,0,0,1,.569,1.312c-.015.541-.2.709-.7.595-.1.123-.174.285-.3.355a.42.42,0,0,1-.652-.357,18.808,18.808,0,0,0-.211-1.936,9.92,9.92,0,0,0-1.017-3.061c-.185-.3-.4-.571-.606-.854a4.631,4.631,0,0,1-1.093-2.824c0-.047-.031-.1-.135-.158a4.156,4.156,0,0,0-.119.583,6.555,6.555,0,0,0,0,.98.842.842,0,0,1-.486.849q-.676.42-1.319.893c-.35.258-.344.5-.082.862.16.224.237.511.4.73a1.763,1.763,0,0,0,.518.434c.178.105.406.121.582.228a.885.885,0,0,1,.46.953,1,1,0,0,1-.945.669,1.892,1.892,0,0,1-1.755-1.242,1.318,1.318,0,0,0-.775-.811.5.5,0,0,1-.248-.241,9.307,9.307,0,0,1-.605-1.369,1.023,1.023,0,0,0-.99-.762c-1.051-.165-2.1-.34-3.141-.58a6.684,6.684,0,0,1-1.427-.589,4.082,4.082,0,0,1-1.78-1.8,12.689,12.689,0,0,0-3.5-4.006,1.426,1.426,0,0,0-1.211-.317c-.75.133-1.52.14-2.28.217a.753.753,0,0,1-.826-.5A2.576,2.576,0,0,1,4.4,8.134a5.855,5.855,0,0,0,.472-.939c.143-.342.073-.429-.294-.446a9.008,9.008,0,0,1-2.99-.5A5.417,5.417,0,0,1,.433,5.567,2.573,2.573,0,0,1,0,4.945",
    transform: "translate(0 0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12939",
    "data-name": "Path 12939",
    d: "M186.045,223.035c1.215.22,2.415.442,3.616.653a.889.889,0,0,1,.716.484c.246.463.563.884.843,1.327a1.329,1.329,0,0,1,.236.464,3.29,3.29,0,0,0,1.209,1.949,5.155,5.155,0,0,1,1.22,2.019c.119.294-.171.577-.526.54a1.5,1.5,0,0,1-.222-.057l.035.132a1.835,1.835,0,0,1-.6.239c-.356,0-.434-.3-.5-.615a10.543,10.543,0,0,0-.376-1.351,4.652,4.652,0,0,0-.526-1.133,14,14,0,0,0-1.5-1.848,3.414,3.414,0,0,0-1.165-.57,4.712,4.712,0,0,1-2.459-2.232",
    transform: "translate(-171.285 -204.784)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBullhornGray);
export default __webpack_public_path__ + "static/media/Bullhorn-gray.8875981b3ea0e12eca057f6fd73e5fe8.svg";
export { ForwardRef as ReactComponent };